export default __webpack_public_path__ + "static/media/Topup.e776ebfb.svg";